import CourseHomologousProcedureAvailableContainer from './CourseHomologousProcedureAvailableContainer';

export default CourseHomologousProcedureAvailableContainer;